// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryPayment  {
    _originalTypeClassName = "Loom.BO.SalaryPayment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryPayment.translate = translateService;
}
this.Id = null;
this.Type = null;
this.PayrollPeriod = null;
this.Date = null;
this.Month = null;
this.Year = null;
this.PaymentType = null;
this.GrossAmount = null;
this.SocialSecurityAmount = null;
this.NetAmount = null;
this.VATAmount = null;
this.TotalCost = null;
this.TaxAmount = null;
this.PayableAmount = null;
this.Hours = null;
this.Comments = null;
this.RelatedInvoiceNo = null;
this.Days = null;
this.IsProjection = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Type:any;
PayrollPeriod:any;
Date:any;
Month:any;
Year:any;
PaymentType:any;
GrossAmount:any;
SocialSecurityAmount:any;
NetAmount:any;
VATAmount:any;
TotalCost:any;
TaxAmount:any;
PayableAmount:any;
Hours:any;
Comments:any;
RelatedInvoiceNo:any;
Days:any;
IsProjection:any;
Contract:any;
Benefit:any;
static setContract = ($this, value) => {
var oldValue = $this.Contract;
$this.Contract = value;
if (value != null) {
if (oldValue != null) {
Domain.EmploymentContract.removePayments(oldValue, $this);
}
Domain.EmploymentContract.addPayments(value, $this);
}
}
static setBenefit = ($this, value) => {
var oldValue = $this.Benefit;
$this.Benefit = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}